import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import { MenuSection, MenuSectionHeading } from '@atlaskit/navigation-system';
import { LinkMenuItem } from '@atlaskit/navigation-system/side-nav-items/link-menu-item';
import { useIntl } from 'react-intl-next';
import type { PreloadedQuery } from 'react-relay';
import { graphql, usePreloadedQuery } from 'react-relay';

import { boysenberryDashboardPath } from '../../../../routes/paths';
import { deserializeAdditionalInfo } from '../../utils/additional-info-json';

import type {
	sessionsListQuery,
	sessionsListQuery$data,
} from './__generated__/sessionsListQuery.graphql';
import messages from './messages';
import { SessionItem } from './session-item';

const SectionList = ({
	sessions,
}: {
	sessions: sessionsListQuery$data['devai_flowSessionsConnectionByCreatorAndCloudId'];
}) => {
	return (sessions?.edges ?? []).map((edge) => {
		const session = edge?.node;
		const { branchName } = deserializeAdditionalInfo(session?.additionalInfoJSON ?? '{}');
		return (
			<SessionItem
				key={session?.id ?? ''}
				sessionId={session?.id ?? ''}
				sessionARI={session?.sessionARI ?? ''}
				name={branchName}
				sessionType="story"
			/>
		);
	});
};

export const SessionsList = ({ queryRef }: { queryRef: PreloadedQuery<sessionsListQuery> }) => {
	const { formatMessage } = useIntl();
	const data = usePreloadedQuery<sessionsListQuery>(
		graphql`
			query sessionsListQuery(
				$first: Int
				$after: String
				$creator: String!
				$cloudId: ID!
				$statusFilter: DevAiFlowSessionsStatus
			) {
				devai_flowSessionsConnectionByCreatorAndCloudId(
					first: $first
					after: $after
					creator: $creator
					cloudId: $cloudId
					statusFilter: $statusFilter
				) @optIn(to: "DevAiFlowSessionsConnectionByCreatorAndCloudId") {
					edges {
						node {
							id
							sessionARI
							status
							additionalInfoJSON
						}
					}
				}
			}
		`,
		queryRef,
	);

	const sessions = data.devai_flowSessionsConnectionByCreatorAndCloudId;

	return (
		<>
			{sessions?.edges != null && sessions?.edges.length > 0 && (
				<MenuSection>
					<MenuSectionHeading>
						{formatMessage(messages.inProgressSessionSectionTitle)}
					</MenuSectionHeading>
					<SectionList sessions={sessions} />
				</MenuSection>
			)}
			<LinkMenuItem elemBefore={<AlignTextLeftIcon label="" />} href={boysenberryDashboardPath}>
				{formatMessage(messages.viewAllSessionsLinkLabel)}
			</LinkMenuItem>
		</>
	);
};
